import React from 'react';
import {Stack, Typography} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import withMainContainer from '../components/WithMainContainer';
import SCButton from '../components/SCButton';

const NotFound = ()=><Stack direction="column" justifyContent="center"
  alignItems="center" gap={2} sx={{marginTop: '40px', marginBottom: '100px'}}>
  <Typography variant="h2">
    אופסי...
  </Typography>
  <Typography variant="h6">
    העמוד לא נמצא
  </Typography>
  <SCButton text="חזרה לדף הבית" variant="contained" size="large"
    icon={<HomeIcon/>} iconPlacement="right" onClick={()=>{ window.location.href = '/'; }}/>
</Stack>;

export default withMainContainer(NotFound);
